export default __webpack_public_path__ + "78f7d6b87cc3e4abe128ff1748518025.png";